import { NextPage } from 'next';
import Image from 'next/image';
import { useState } from 'react';

import CollaboratorInfoForm, {
  CollaboratorInfo,
} from '~components/uas-collaborators/CollaboratorInfoForm';
import Success from '~components/uas-collaborators/Success';
import PersonalInfoForm, { PersonalInfo } from '~components/uas/PersonalInfoForm';
import PhoneVerification from '~components/uas/PhoneVerification';
import { Taker } from '~components/uas/Success';
import Layout from '~components/ui/Layout';
import Loading from '~components/ui/Loading';
import Steps from '~components/ui/Steps';
import { postToAPI } from '~utils/api/common';

import logoUas from '../public/img/uas_logo.png';

const smsEndpoint = '/uas-collaborators/send-sms-code';

const UasCollaboratorsPage: NextPage = () => {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [collaboratorData, setCollaboratorData] = useState<CollaboratorInfo>();
  const [personalData, setPersonalData] = useState<PersonalInfo>();
  const [taker, setTaker] = useState<Taker>();

  const addTaker = (verificationCode: string) => {
    setLoading(true);
    postToAPI('/uas-collaborators/create-taker', {
      ...personalData,
      ...collaboratorData,
      verificationCode,
    })
      .then((response) => {
        setTaker(response);
        setStep(4);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Layout
      meta={{
        title: 'Registro colaboradores UAS',
        description: 'Registro colaboradores UAS',
      }}
      headerType="opaque"
    >
      <section className="mx-auto mb-12 mt-4 flex max-w-2xl flex-col items-center space-y-8 px-4">
        <Image src={logoUas} alt="logo UAS" width={100} />
        <Steps step={step} />
        <Loading show={loading} label="Validando código" containerClassName="w-full">
          <div className="rounded-xl border dark:border-neutral-600">
            {step === 1 && (
              <CollaboratorInfoForm
                onContinue={(data) => {
                  setCollaboratorData(data);
                  setStep(2);
                }}
              />
            )}
            {step === 2 && (
              <PersonalInfoForm
                defaultValues={{ lastName: collaboratorData?.lastName }}
                smsEndpoint={smsEndpoint}
                subtitle="Completa tu información para registrarte en el programa de beneficios para colaboradores"
                infoText="Tu número de teléfono verificado te permitirá acceder a los beneficios de Citicinemas que la Universidad Autonoma de Sinaloa ofrece a sus colaboradores."
                onContinue={(data) => {
                  setPersonalData(data);
                  setStep(3);
                }}
                onBack={() => setStep(1)}
              />
            )}
            {step === 3 && personalData && (
              <PhoneVerification
                phone={personalData.phone}
                name={personalData.name}
                smsEndpoint={smsEndpoint}
                description="Este paso es necesario para confirmar tu identidad y acceder a los beneficios de Citicinemas que la Universidad Autonoma de Sinaloa ofrece a sus colaboradores."
                onContinue={(code) => addTaker(code)}
                onBack={() => setStep(2)}
              />
            )}
            {step === 4 && taker && collaboratorData && (
              <Success data={{ ...taker, ...collaboratorData }} />
            )}
          </div>
        </Loading>
      </section>
    </Layout>
  );
};

export default UasCollaboratorsPage;
